import { render } from "./NewsSwiper.vue?vue&type=template&id=1f093d8c&scoped=true"
import script from "./NewsSwiper.vue?vue&type=script&lang=js"
export * from "./NewsSwiper.vue?vue&type=script&lang=js"

import "./NewsSwiper.vue?vue&type=style&index=0&id=1f093d8c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f093d8c"]])

export default __exports__